module.exports = __webpack_public_path__ + "static/img/mobileBgPic.ee4aa6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/GreenIQ/mobileBgPic.png
// module id = BE8s
// module chunks = 0